import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';
import { loading } from 'State/actions';

export const getSitesByFiscalYear = fiscalYear => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CEP_SETUP_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `cep/ByFiscalYear/${fiscalYear}`
      );
      dispatch({
        type: types.CEP_SETUP_GET_SITES_BY_FISCAL_YEAR,
        payload: response.data.Data ? response.data.Data : 'Sites not found.',
      });
    } catch (error) {
      dispatch({
        type: types.CEP_SETUP_ERRORS,
        payload: error.response,
      });
    }
    dispatch(loading(types.CEP_SETUP_LOADING, false));
  };
};

export const getFiscalYears = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.CEP_SETUP_GET_FISCAL_YEARS,
        types.CEP_SETUP_LOADING,
        types.CEP_SETUP_ERRORS,
        'ControlInfo/FiscalYears'
      )
    );
  };
};

export const setSiteDataByFiscalYear = models => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CEP_SETUP_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(`cep/Update/`, models.Sites);
    } catch (error) {
      dispatch({
        type: types.CEP_SETUP_ERRORS,
        payload: error.response,
      });
    }

    dispatch(loading(types.CEP_SETUP_LOADING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/cepsetup/state/setup/actions.js